module.exports = __webpack_public_path__ + "img/temp-bar-graph.4433a0fe.jpg";